export default __webpack_public_path__ + "static/media/Prison-3D-Model-06.1f5efbe4.jpg";